"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@dnd-kit/core");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _Header = _interopRequireDefault(require("./Header"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function Sheet(_ref) {
  var header = _ref.header,
    children = _ref.children,
    expanded = _ref.expanded,
    _ref$maxHeight = _ref.maxHeight,
    maxHeight = _ref$maxHeight === void 0 ? '75vh' : _ref$maxHeight,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? '500px' : _ref$maxWidth,
    variant = _ref.variant,
    headerVariant = _ref.headerVariant,
    onClick = _ref.onClick;
  var _useDraggable = (0, _core.useDraggable)({
      id: 'header'
    }),
    setNodeRef = _useDraggable.setNodeRef,
    attributes = _useDraggable.attributes,
    listeners = _useDraggable.listeners,
    isDragging = _useDraggable.isDragging,
    transform = _useDraggable.transform;
  return /*#__PURE__*/_react["default"].createElement(StyledSheet, {
    style: {
      '--max-height': maxHeight,
      '--transform': transform ? "".concat(transform.y, "px") : undefined
    },
    dragging: isDragging,
    maxWidth: maxWidth,
    expanded: expanded,
    variant: variant
  }, /*#__PURE__*/_react["default"].createElement(_Header["default"], _extends({
    onClick: onClick,
    dragging: isDragging,
    ref: setNodeRef
  }, listeners, attributes, {
    variant: headerVariant
  }), header), /*#__PURE__*/_react["default"].createElement(StyledContent, {
    variant: variant
  }, children));
}
var _default = Sheet;
exports["default"] = _default;
var StyledSheet = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tposition: relative;\n\t--radius: 25px;\n\tborder-top-left-radius: var(--radius);\n\tborder-top-right-radius: var(--radius);\n\tpointer-events: all;\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\tmax-width: 500px;\n\tmax-height: var(--max-height);\n\ttransition: transform 200ms ease;\n\ttransform: translate3d(\n\t\t0,\n\t\tcalc(100% - var(--header-height) + var(--transform, 0px)),\n\t\t0\n\t);\n\t&:after {\n\t\tcontent: '';\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbottom: 1px;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttransform: translateY(100%);\n\t\tbackground-color: inherit;\n\t}\n\ttransition: ", ";\n\ttransform: ", ";\n\t", ";\n\t", "\n\t", "\n\t", "\n"])), function (props) {
  return props.dragging && 'none';
}, function (props) {
  return props.expanded && 'translate3d(0, var(--transform), 0)';
}, _styledSystem.maxWidth, (0, _styledSystem.variant)({
  prop: 'variant',
  scale: 'backgrounds'
}), function (_ref2) {
  var theme = _ref2.theme;
  return "".concat(theme.mediaQueries.medium, "{\n\t\t").concat((0, _styledSystem.variant)({
    prop: 'variant',
    scale: 'backgrounds'
  }), "\n\t}");
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.mediaQueries.large, "{\n\t\t").concat((0, _styledSystem.variant)({
    prop: 'variant',
    scale: 'backgrounds'
  }), "\n\t}");
});
var StyledContent = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: block;\n\toverflow-y: auto;\n\tbackground-color: inherit;\n"])));